const DELTA = 'delta';
const DEFAULT = 'default';

export default {
  DELTA,
  DEFAULT
};
